// extracted by mini-css-extract-plugin
module.exports = {"container":"dl","item":"dm","itemSingle":"dn","itemContainer":"do","icon":"dp","title":"dq","text":"dr","link":"ds"};